module.exports = __webpack_public_path__ + "img/NW.193863ca.svg";